
export default {
    getMockupData:function (){
        if (window && window.walkuere_app_data && window.walkuere_app_data.mockup_session_data) {
            var dataUrl = window.location.origin+window.walkuere_app_data.mockup_session_data;
            if (dataUrl && dataUrl.length) {
                const requestOptions = {
                    method: "POST",
                };
                  return fetch(dataUrl, requestOptions)
                  .then((response) => response.json())
                  .then((responseData) => {
                    return responseData;
                  })
            }
            
        }
    },
    getMockupDataForSpeakerDetail:function(){
      var dataUrl = window.location.origin+'/wp-content/themes/sands-events-subtheme/js/speaker-detail.json';
      if (dataUrl && dataUrl.length) {
          const requestOptions = {
              method: "POST",
          };
            return fetch(dataUrl, requestOptions)
            .then((response) => response.json())
            .then((responseData) => {
              return responseData;
            })
      }
    }
  }